export const areNumbersSequential = (arr) => {
  return arr.every(function (num, i) {
    return i === 0 || num > arr[i - 1];
  });
};
